import toggleTabs from "./tabs";

const translateSelector = '.goog-te-combo';
const langStringSelector = '.language-label';
const smallLangStringSelector = '.language-label-small';


function changeLangSetting(e){
    const translateSelect = e.target.closest(translateSelector);
    if (translateSelect){
        const langString = document.querySelector(langStringSelector);
        const smallLangstring = document.querySelector(smallLangStringSelector);
        const langIndex = translateSelect.selectedIndex;
        const selectedLang = translateSelect.querySelector(`:nth-child(${langIndex + 1})`);
        langString.innerHTML = selectedLang.innerHTML;
        smallLangstring.innerHTML = selectedLang.value;
    }
}

function loadLangSetting(){
    const selectedLangSelect = document.querySelector('.goog-te-combo > :checked');
    let selectedLang = selectedLangSelect.innerHTML;
    let smallSelectedLang = selectedLangSelect.value;
    if (selectedLang === 'Select Language'){
        selectedLang = 'English';
        smallSelectedLang = 'en';
    }
    document.querySelector(langStringSelector).innerHTML = selectedLang;
    document.querySelector(smallLangStringSelector).innerHTML = smallSelectedLang;
}

export default {changeLangSetting, loadLangSetting};